import { LockKey, ShieldCheck } from '@phosphor-icons/react';
import { useState, type FormEvent } from 'react';
import { useAuth } from '../auth/AuthContext';
import styles from './LoginPage.module.css';

export function LoginPage({ initialError }: { initialError?: string }) {
  const { login, confirmNewPassword, needsNewPassword } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(initialError);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(undefined);
    try {
      if (needsNewPassword) {
        if (password.length < 12) throw new Error('Use pelo menos 12 caracteres.');
        if (password !== confirmation) throw new Error('As senhas não conferem.');
        await confirmNewPassword(password);
      } else {
        await login(email.trim(), password);
        setPassword('');
      }
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : 'Não foi possível entrar.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className={styles.page}>
      <section className={styles.panel}>
        <div className={styles.brand}><span>K</span><strong>KemiControl</strong></div>
        <div className={styles.copy}>
          <div className={styles.icon}><LockKey size={27} weight="duotone" /></div>
          <h1>{needsNewPassword ? 'Crie sua senha' : 'Entre na sua conta'}</h1>
          <p>{needsNewPassword ? 'A senha temporária só vale para este primeiro acesso.' : 'Seu controle financeiro, disponível também sem internet neste dispositivo.'}</p>
        </div>
        <form onSubmit={submit} className={styles.form}>
          {!needsNewPassword && <div className="field"><label htmlFor="email">E-mail</label><input id="email" type="email" autoComplete="username" required value={email} onChange={(event) => setEmail(event.target.value)} /></div>}
          <div className="field"><label htmlFor="password">{needsNewPassword ? 'Nova senha' : 'Senha'}</label><input id="password" type="password" autoComplete={needsNewPassword ? 'new-password' : 'current-password'} required value={password} onChange={(event) => setPassword(event.target.value)} /></div>
          {needsNewPassword && <div className="field"><label htmlFor="confirmation">Confirme a senha</label><input id="confirmation" type="password" autoComplete="new-password" required value={confirmation} onChange={(event) => setConfirmation(event.target.value)} /></div>}
          {error && <p className={styles.error} role="alert">{error}</p>}
          <button className="primary-button" type="submit" disabled={busy}>{busy ? 'Aguarde…' : needsNewPassword ? 'Salvar senha e entrar' : 'Entrar'}</button>
        </form>
        <p className={styles.security}><ShieldCheck size={17} weight="duotone" /> Convites são criados pelo administrador. Não há cadastro público.</p>
      </section>
    </main>
  );
}
